(ns machtfit.api
  (:require [clojure.string :as str]
            [re-frame.core :as rf]))

(defn auth-redirect-url [path response]
  (some (fn [{:keys [error]}]
          (when-let [redirect-url (:redirect_url error)]
            (if (and (= (:name error) "login-required")
                     (not (str/starts-with? path redirect-url)))
              (str redirect-url (if (str/includes? redirect-url "?") "&" "?")
                   "next=" (js/encodeURIComponent path))
              redirect-url)))
        (-> response :result vals)))

(defn- current-path []
  (let [location (.. js/window -top -location)]
    (str (.-pathname location) (.-search location) (.-hash location))))

(defn bare-request [db options]
  (merge {:url (if (some #{:products :products-fast :products-faster} (map first (:data options))) "/api/products/" "/api/")
          ;; Warning: not all apps use this path
          :csrf-token (:csrf-token db)
          :response-format :json}
         (update options :on-success
                 (fn [success-handler]
                   (fn [response]
                     (if-let [url (auth-redirect-url (current-path) response)]
                       (rf/dispatch [:redirect url])
                       (when success-handler
                         (success-handler response))))))))

(rf/reg-event-db ::api-error-received
  (fn [db _]
    (assoc db :error? true)))

(defn request [db options]
  (bare-request db (update options :on-error (fn [error-handler]
                                               (fn [err]
                                                 (when error-handler
                                                   (error-handler err))
                                                 (rf/dispatch [::api-error-received]))))))
